<template>
  <div>
   <Projects />
  </div>
</template>

<script>
import Projects from '@/components/Projects'

export default {
  name: 'Portafolio',
  components: {
    Projects
  }
}
</script>

<style scoped>
  
</style>
